<mdb-checkbox data-cy='carrier-checkbox' id='carrier-checkbox-{{carrier.name}}' *ngFor='let carrier of data.availableCarriers' [hidden]='!carrier.isDisplayed' [(ngModel)]='carrier.isSelected' [inline]='true'>{{carrier.name}}</mdb-checkbox>
<span class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</span>
